import { apiSlice } from '../../api/apiSlice';
import { store } from '../../store/store';

export function logToServer(employeenumber:string,description: string): void {
   store.dispatch(apiSlice.endpoints.addUserActivityLog.initiate({
    employeenumber,
    description
}));

}
